import axios from 'axios';

export interface BalanceCheckResponse {
  canProceed: boolean;
  currentBalance: number;
  hasActiveContract: boolean;
  estimatedCost?: number;
}

export interface CreditRequestEmailResponse {
  success: boolean;
  messageId?: string;
  message?: string;
}

export const checkCreditBalance = async (divisionId: string): Promise<BalanceCheckResponse> => {
  const response = await axios.post<BalanceCheckResponse>('/api/credits/balanceCheck', {
    divisionId,
    serviceGroup: 'ai_services'
  });
  return response.data;
};

export const sendCreditRequestEmail = async (product: string): Promise<CreditRequestEmailResponse> => {
  const response = await axios.post<CreditRequestEmailResponse>('/api/credits/requestPurchase', {
    product
  });
  return response.data;
};
